import { render } from "./Footer.vue?vue&type=template&id=90f89e16&scoped=true&ts=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=90f89e16&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90f89e16"]])

export default __exports__